import { render, staticRenderFns } from "./WhatsappPhone.vue?vue&type=template&id=71992191&"
import script from "./WhatsappPhone.vue?vue&type=script&lang=js&"
export * from "./WhatsappPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports